import api from './api';

// Obtener todos los tipos de productos
export const getAllProductTypes = async () => {
  try {
    const response = await api.get('/product-types');
    return response.data;
  } catch (error) {
    console.error('Error al obtener product types:', error);
    throw error;
  }
};

// Obtener un tipo de producto por ID
export const getProductTypeById = async (id) => {
  try {
    const response = await api.get(`/product-types/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error al obtener product type:', error);
    throw error;
  }
};

// Crear un nuevo tipo de producto
export const createProductType = async (data) => {
  try {
    const response = await api.post('/product-types', data);
    return response.data;
  } catch (error) {
    console.error('Error al crear product type:', error);
    throw error;
  }
};

// Actualizar un tipo de producto
export const updateProductType = async (id, data) => {
  try {
    const response = await api.put(`/product-types/${id}`, data);
    return response.data;
  } catch (error) {
    console.error('Error al actualizar product type:', error);
    throw error;
  }
};

// Eliminar un tipo de producto
export const deleteProductType = async (id) => {
  try {
    const response = await api.delete(`/product-types/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error al eliminar product type:', error);
    throw error;
  }
};